// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__jZA47","buttonContainer":"styles_buttonContainer__BtAh+","texto":"styles_texto__SRI19","containerCheck":"styles_containerCheck__FidUI"};